import { TrendGraphView } from './trend-graph-view';
import { CustomGroup } from './custom-group';
import { DashboardPanelType } from './dashboard-panel-type';
import { ChannelGroup } from './channel-group';

export interface DashboardPanelParameters {
    type: DashboardPanelType;
    params: any;
}

export function createAlarmPanelParameters(): DashboardPanelParameters {
    return create(DashboardPanelType.ALARMS, {});
}

export function createTrendGraphPanelParameters(graph: TrendGraphView): DashboardPanelParameters {
    return create(DashboardPanelType.TREND_GRAPH, { graphId: graph.id });
}

export function createChannelGroupPanelParameters(group: ChannelGroup): DashboardPanelParameters {
    return create(DashboardPanelType.CHANNEL_GROUP, { groupId: group.id });
}

export function createCustomGroupPanelParameters(group: CustomGroup): DashboardPanelParameters {
    return create(DashboardPanelType.CUSTOM_GROUP, { groupId: group.id });
}

export function createMimicPanelParameters(mimicView: any): DashboardPanelParameters {
    return create(DashboardPanelType.MIMICS, { mimicId: mimicView.id });
}

function create(type: DashboardPanelType, params: object): DashboardPanelParameters {
    return {
        type,
        params,
    };
}
